/** @format */

import * as Sentry from '@sentry/angular';
import { includes } from 'lodash-es';

export interface InitializeSentryOptions {
  debug?: boolean;
  dsn: string;
  environment: string;
  release?: string;
  tracePropagationTargets: string[];
  excludedRejections?: string[];
  excludedStatuses?: number[];
  isDisabled?: boolean;
  tracesSampleRate?: number;
}

export function initializeSentry(options: InitializeSentryOptions): void {
  if (options.isDisabled) return;

  const excludedRejections = options.excludedRejections ?? [];
  const excludedStatuses = options.excludedStatuses ?? [401, 403, 404];

  Sentry.init({
    debug: options.debug ?? false,
    dsn: options.dsn,
    environment: options.environment,
    release: options.release,
    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: options.tracePropagationTargets,
    tracesSampleRate: options.tracesSampleRate ?? 1.0,
    beforeSend(event, hint) {
      if (!event.exception || !hint.originalException) return event;

      const originalException = hint.originalException as any;
      const rejection = originalException.rejection;
      const rejectionMessage = typeof rejection === 'string' ? rejection : rejection?.message;

      if (rejectionMessage && includes(excludedRejections, rejectionMessage)) return null;
      if (includes(excludedStatuses, originalException?.status)) return null;
      if (includes(excludedStatuses, rejection?.response?.status)) return null;

      return event;
    },
  });
}
